// reducer.js
import {
  GET_ADGROUP_NOTES,
  GET_ADGROUP_NOTES_SUCCESS,
  GET_ADGROUP_NOTES_ERROR,
  CREATE_ADGROUP_NOTES,
  CREATE_ADGROUP_NOTES_SUCCESS,
  CREATE_ADGROUP_NOTES_ERROR,
  UPDATE_ADGROUP_NOTES,
  UPDATE_ADGROUP_NOTES_SUCCESS,
  UPDATE_ADGROUP_NOTES_ERROR,
  DELETE_ADGROUP_NOTES,
  DELETE_ADGROUP_NOTES_SUCCESS,
  DELETE_ADGROUP_NOTES_ERROR,
} from "./actionTypes";

const initialState = {
  ad_group_notes_loading: false,
  ad_group_notes_error: null,
  ad_group_notes: [],
};

const adgroupNotesReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ADGROUP_NOTES:
    case CREATE_ADGROUP_NOTES:
    case UPDATE_ADGROUP_NOTES:
    case DELETE_ADGROUP_NOTES:
      return {
        ...state,
        ad_group_notes_loading: true,
        ad_group_notes_error: null,
      };

    case GET_ADGROUP_NOTES_SUCCESS:
      return {
        ...state,
        ad_group_notes_loading: false,
        ad_group_notes: action.payload,
      };
    case CREATE_ADGROUP_NOTES_SUCCESS:
      return {
        ...state,
        ad_group_notes_loading: false,
        ad_group_notes: [...state.ad_group_notes, action.payload],
      };
    case UPDATE_ADGROUP_NOTES_SUCCESS:
      return {
        ...state,
        ad_group_notes_loading: false,
        ad_group_notes: state.ad_group_notes.map((ad_group_note) => {
        if (ad_group_note.id === action.payload.id) {
          return action.payload
        }
        return ad_group_note
      }),
    }
    case DELETE_ADGROUP_NOTES_SUCCESS:
      return {
        ...state,
        ad_group_notes_loading: false,
        ad_group_notes: state.ad_group_notes.filter(
          (ad_group_note) => ad_group_note.id !== action.payload.id
        )
      };

    case GET_ADGROUP_NOTES_ERROR:
    case CREATE_ADGROUP_NOTES_ERROR:
    case UPDATE_ADGROUP_NOTES_ERROR:
    case DELETE_ADGROUP_NOTES_ERROR:
      return {
        ...state,
        ad_group_notes_loading: false,
        ad_group_notes_error: action.payload,
      };

    default:
      return state;
  }
};

export default adgroupNotesReducer;
